import { AccidentAndInjuryClaims } from '../components/AccidentAndInjuryClaims'
import { ClaimsFilters } from '../components/ClaimsFilters'
import { CheckYourClaims } from '../components/CheckYourClaims'
import { MAClaims } from '../components/MAClaims'
import { ClaimResults } from '../components/ClaimResults'
import { RelatedResources } from '../components/RelatedResources'

export interface ClaimsSearchPageContentProps {
  isEMsnPreferred: boolean | undefined
  displayMAContent: boolean | null | undefined
  handleSearchAnywayClick: () => void
}

/**
 * Temporary helper component until jest fake timers works properly with fetching
 * user.
 */
export const ClaimsSearchPageContent: React.FC<ClaimsSearchPageContentProps> = ({
  isEMsnPreferred,
  displayMAContent,
  handleSearchAnywayClick
}) => {
  return (
    <>
      <CheckYourClaims isEMsnPreferred={isEMsnPreferred}/>
      {displayMAContent && (
        <MAClaims eventAction={handleSearchAnywayClick}></MAClaims>
      )}
      {!displayMAContent && (
        <>
          <ClaimsFilters className='ds-u-margin-top--3' />
          <ClaimResults className='ds-u-margin-top--3' />
        </>
      )}
      <AccidentAndInjuryClaims className='ds-u-margin-top--6 ds-u-margin-bottom--3' />
      <RelatedResources />
    </>
  )
}
